var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "columns" }, [
    _c("div", { staticClass: "column is-one-third" }, [_c("PreviewWidget")], 1),
    _c(
      "div",
      { staticClass: "column is-two-third" },
      [_c("ListWidgetSetting")],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }